import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isOpen: false,
  isMobileOpen: false,
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
    openCollapseSidebar: (state) => {
      state.isOpen = true;
    },
    toggleMobileSidebar: (state) => {
      state.isMobileOpen = !state.isMobileOpen;
      state.isOpen = true;
    },
  },
});

export const { toggleSidebar, toggleMobileSidebar, openCollapseSidebar } =
  sidebarSlice.actions;

export default sidebarSlice.reducer;
